var map = {
	"./qq.svg": "1430",
	"./status-close.svg": "a2ab",
	"./status-pass.svg": "f91d",
	"./status-payment.svg": "2c4b",
	"./status-recived.svg": "47a6",
	"./status-refund.svg": "0617",
	"./status-shipped.svg": "6968",
	"./status-unpass.svg": "d15c",
	"./unionpay.svg": "aa98",
	"./wx.svg": "ddee"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";